"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _require = require('yup'),
    bool = _require.bool,
    number = _require.number,
    object = _require.object,
    string = _require.string,
    array = _require.array;

var RssModel = require('../RssModel');

var RELATIONSHIP_SOURCE = require('../../constant/relationship/source.constant');

var DEFAULT_CODE_YEAR = 2016;

var Building = /*#__PURE__*/function (_RssModel) {
  _inherits(Building, _RssModel);

  var _super = _createSuper(Building);

  function Building() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Building);

    return _super.call(this, payload);
  } // eslint-disable-next-line class-methods-use-this


  _createClass(Building, [{
    key: "schema",
    value: function schema() {
      return object().shape({
        id: string().required(),
        buildingKey: string().required(),
        name: string().min(1).max(128).trim().required().label('Name'),
        alternativeNames: array().of(string().trim()).ensure().label('Alternative Names'),
        code: string().max(32).trim().nullable()["default"](null).label('Code'),
        category: string().max(64).trim().nullable()["default"](null).label('Category'),
        ubccode: string().max(32).trim().nullable()["default"](null).label('Uniform Building Code'),
        assetNumber: string().max(32).trim().nullable()["default"](null).label('Asset Number'),
        primaryUsage: string().max(128).trim().nullable()["default"](null).label('Primary Usage'),
        address: string().max(128).trim().nullable()["default"](null).label('Address'),
        city: string().max(64).trim().nullable()["default"](null).label('City'),
        county: string().max(64).trim().nullable()["default"](null).label('County'),
        state: string().max(32).trim().nullable()["default"](null).label('State'),
        postalCode: string().max(32).trim().nullable()["default"](null).label('Postal Code'),
        size: number().positive().transform(function (value) {
          return Number.isInteger(value) ? parseInt(value, 10) : null;
        }).nullable().max(99999999999)["default"](null).label('Size'),
        codeYear: number().required().positive().transform(function (value) {
          return Number.isInteger(value) ? parseInt(value, 10) : null;
        }).integer().max(9999)["default"](DEFAULT_CODE_YEAR).required().label('Code Year'),
        fireSuppressionCoverage: bool()["default"](false).label('Fire Suppression Coverage'),
        source: string().oneOf(Object.keys(RELATIONSHIP_SOURCE))["default"](RELATIONSHIP_SOURCE.RSS).required().label('Source')
      });
    }
  }]);

  return Building;
}(RssModel);

module.exports = Building;